var $ccbe6066c10b1e53$exports = {};
$ccbe6066c10b1e53$exports = {
  "close": "St\xE4ng",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " meddelande");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " meddelanden");
      }
    }), ".");
  }
};
export { $ccbe6066c10b1e53$exports as default };